import ForgotPage from "../app/auth/forgot";
import ResetPasswordPage from "../app/auth/forgot/ResetPassword";
import LoginPage from "../app/auth/login";
import Banners from "../app/banners";
import Category from "../app/category";
import CommissionsPage from "../app/commissions";
import DashboardPage from "../app/dashboard";
import Faq from "../app/faqs";
import ReturnOrders from "../app/returnOrders";
import Setting from "../app/settings";
import SponsoredVendorsPage from "../app/sponsoredVendors";
import UsersPage from "../app/users";
import VendorsPage from "../app/vendors";
import WithDrawalsPage from "../app/withDrawals";
import { APP_ICONS } from "../assets";

export const ADMIN_ROUTES = [
  {
    id: 1,
    name: "Dashboard",
    path: "/",
    component: <DashboardPage />,
    activeIcon: APP_ICONS.dashboardIconWhite,
    inActiveIcon: APP_ICONS.dashboardIconBlack,
  },
  {
    id: 2,
    name: "FAQ",
    path: "/faq",
    activeIcon: APP_ICONS.faqIcon,
    component: <Faq />,
    inActiveIcon: APP_ICONS.faqIcon,
  },
  {
    id: 3,
    name: "Category",
    path: "/category",
    component: <Category />,
    activeIcon: APP_ICONS.categoryIcon,
    inActiveIcon: APP_ICONS.categoryIcon,
  },

  {
    id: 4,
    name: "Banners",
    path: "/banners",
    component: <Banners />,

    // activeIcon: APP_ICONS.categoryIcon,
    // inActiveIcon: APP_ICONS.categoryIcon,
  },
  {
    id: 5,
    name: "Vendors",
    path: "/vendors",
    component: <VendorsPage />,
    activeIcon: APP_ICONS.homeIconWhite,
    inActiveIcon: APP_ICONS.homeIconBlack,
  },
  {
    id: 6,
    name: "Return Orders",
    path: "/return-orders",
    component: <ReturnOrders />,
    activeIcon: APP_ICONS.homeIconWhite,
    inActiveIcon: APP_ICONS.homeIconBlack,
  },
  {
    id: 7,
    name: "Users",
    component: <UsersPage />,
    path: "/users",
    activeIcon: APP_ICONS.userIconWhite,
    inActiveIcon: APP_ICONS.userIconBlack,
  },
  {
    id: 8,
    name: "Withdrawals",
    path: "/withdrawals",
    component: <WithDrawalsPage />,
    activeIcon: APP_ICONS.cashIconWhite,
    inActiveIcon: APP_ICONS.cashIconBlack,
  },
  {
    id: 9,
    name: "Commissions",
    path: "/commissions",
    component: <CommissionsPage />,

    activeIcon: APP_ICONS.timerIconWhite,
    inActiveIcon: APP_ICONS.timerIconBlack,
  },
  {
    id: 10,
    name: "settings",
    path: "/setting",
    component: <Setting />,

    activeIcon: APP_ICONS.timerIconWhite,
    inActiveIcon: APP_ICONS.timerIconBlack,
  },
  // {
  //   id: 10,
  //   name: "Sponsored Vendors",
  //   path: "/sponsored-vendors",
  //   component: <SponsoredVendorsPage />,
  //   activeIcon: APP_ICONS.homeIconWhite,
  //   inActiveIcon: APP_ICONS.homeIconBlack,
  // },
];

export const AuthRoutes = [
  {
    id: 1,
    name: "Login",
    component: <LoginPage />,
    path: "/login",
    icon: "location_on",
  },
  {
    id: 2,
    name: "Forgot",
    component: <ForgotPage />,
    path: "/forgot-password",
    icon: "location_on",
  },
  {
    id: 4,
    name: "Reset Password",
    component: <ResetPasswordPage />,
    path: "/reset-password",
    icon: "location_on",
  },
];
